import callApiAxiosClient from '../../axios/axios_client';
import { technicalIncidentGetRequest, technicalIncidentList } from '../../models';

async function getTechnicalIncidents(params?: technicalIncidentGetRequest): Promise<technicalIncidentList> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = `Bearer ${token.token}`;

  return callApiAxiosClient<technicalIncidentList>({
    method: 'get',
    url: 'technicalincidents',
    headers: {
      'Content-Type': 'Application/json',
      Authorization: authorization,
    },
    params: {
      Status: params?.status,
      EventType: params?.eventType,
      Skip: params?.skip,
      Take: params?.take,
    },
  });
}

export default getTechnicalIncidents;
